import React from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";

const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.common.white
        : theme.palette.grey[600],
    color: theme.palette.text.primary,
    borderRadius: "0 0 5px 5px",
  },
}));

interface UserMenuProps {
  anchorEl: null | HTMLElement;
  isMenuOpen: boolean;
  username: string;
  menuId: string;
  onClose: () => void;
  onBulkMove?: () => void;
  onSendFeedback: () => void;
  onLogout: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({
  anchorEl,
  isMenuOpen,
  username,
  menuId,
  onClose,
  onBulkMove,
  onSendFeedback,
  onLogout,
}) => (
  <StyledMenu
    anchorEl={anchorEl}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    id={menuId}
    keepMounted
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    open={isMenuOpen}
    onClose={onClose}
  >
    <Box sx={{ display: { xs: "inline", md: "none" } }}>
      <MenuItem>{username}</MenuItem>
      <Divider />
    </Box>
    {onBulkMove && <MenuItem onClick={onBulkMove}>Bulk Move</MenuItem>}
    <MenuItem
      component={Link}
      to="/sii-fund-labels"
      onClick={onClose}
      data-test-id="sii-fund-labels-menu-item"
    >
      SII Fund Labels
    </MenuItem>
    <MenuItem onClick={onSendFeedback}>Send feedback</MenuItem>
    <MenuItem onClick={onLogout} color="inherit">
      Logout
    </MenuItem>
  </StyledMenu>
);

export default UserMenu;
